import React from 'react';

import { List, Avatar, Icon, Typography } from 'antd';

const { Paragraph } = Typography;

class CoreContentResponsive extends React.Component {

  render() {
    let src = "";
    return(
        <List
          itemLayout="vertical"
          size="default"
          pagination={{
            onChange: page => {
              console.log(page);
            },
            pageSize: 10,
          }}
          dataSource={this.props.data}
          renderItem={item => (
            <List.Item
              key={item.title}
              extra={
                <img
                  width={272}
                  height={145}
                  alt = "" //"Doofus no thumbnail here!"
                  src={item.thumbnail}
                />
              }
            >
              <List.Item.Meta
                style={{padding: 20}}
                avatar={
                  <Avatar
                  src={typeof item.author_avatar[0] === 'undefined' ?
                            src="https://s3.amazonaws.com/panzofi.com/Avatar.png4"
                          : src=`${item.author_avatar[0]["profile_picture"]}`}
                  />
                }
                title={<a href={`/core/${item.slug}`}>{item.title}</a>}
                description={<Paragraph ellipsis={{ rows: 2, expandable: true }}>{item.description}</Paragraph>}
              />

            </List.Item>
          )}
        />
    );
  };

}

export default CoreContentResponsive;
